import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { TableComponent, DataReloadEvent, TableColumn, IdentifierTableColumn, DateTableColumn, CheckboxComponent } from '@serengeti/serengeti-common';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TaskScheduleVariableService } from '../../service/variable.service';

@Component({
  selector: 'app-task-schedule-variable-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class TaskScheduleVariableListComponent implements OnInit {
	searchName: string;

	_searchControl: ElementRef;
	@ViewChild('searchControl', { static: false }) set searchControl(_searchControl: ElementRef) {
		this._searchControl = _searchControl;
		if (_searchControl) {
			_searchControl.nativeElement.addEventListener('keypress', (e: KeyboardEvent) => {
				if (e.key === "Enter") {
					this.doRefresh();
				}
		 	});
		}
	}
	get searchControl(): ElementRef {
		return this._searchControl;
	}
	
	oldSearch: string;
	@ViewChild('variableList', {static: true }) variableList: TableComponent;

	currentCondition: DataReloadEvent;
	columns: TableColumn[] = [
		new IdentifierTableColumn('id', 'setting.task.schedule.variable.list.content.column.select', false).withType(CheckboxComponent),
		new TableColumn('name', 'setting.task.schedule.variable.list.content.column.name'),
		new TableColumn('variableName', 'setting.task.schedule.variable.list.content.column.variable-name'),
		new TableColumn('variableType', 'setting.task.schedule.variable.list.content.column.variable-type'),
		new TableColumn('apiName', 'setting.task.schedule.variable.list.content.column.api-name'),
		new TableColumn('apiUrl', 'setting.task.schedule.variable.list.content.column.api-url'),
		new DateTableColumn('createdDate', 'setting.task.schedule.variable.list.content.column.created-date')
	];

	constructor(
		private router: Router,
		private variableService: TaskScheduleVariableService,
		private translateService: TranslateService) {
  }

	ngOnInit() {
		this.doRefresh();
	}

	doRefresh() {
		if (this.oldSearch && this.oldSearch === this.searchName) {
			return;
		} else {
			this.oldSearch = this.searchName;
			
			this.doReload(new DataReloadEvent('name', 'desc', 0, this.variableList.pageSize, this.searchName));
		}
	}

	doReload(condition?: DataReloadEvent) {
		if (condition) {
			this.currentCondition = condition;
		} else {
			condition = this.currentCondition;
		}

		this.variableService.search(condition.filter, condition.active, condition.sortOrder, condition.pageNumber, condition.pageSize)
			.subscribe((resultPage: { totalElements: number; content: any[]; }) => {
				this.variableList.refresh(resultPage.totalElements, resultPage.content, this.columns, condition);
			});
	}

	doDelete() {
		this.variableList.getElements().forEach(variable => {
			if (variable.isSelected()) {
        this.translateService.get(['setting.task.schedule.variable.list.confirm.delete']).subscribe((messages: any) => {
          if (confirm(messages['setting.task.schedule.variable.list.confirm.delete'])) {
            this.variableService.delete(variable.getData().id).subscribe(_ => {
              this.doRefresh();
            });
          }
        });
			}
		});

	}

	goDetail($event: any) {
		const variable = $event.element.getData();

		this.router.navigate(['/main', { outlets: { content: 'setting/task/schedule/variable/detail/' + variable.id + '/' }}]);
	}

}
